/* istanbul ignore file */
import React, { useEffect } from 'react';
import {
  AuthorizationRequest,
  AuthorizationServiceConfiguration,
  DefaultCrypto,
  FetchRequestor,
  LocalStorageBackend,
  RedirectRequestHandler,
} from '@openid/appauth';
import environment from 'environment';
import { NoHashQueryStringUtils } from 'auth/noHashQueryStringUtils';
import { FpLoading } from 'components/atoms/FpLoading';

export function FpLogin(props: any) {
  useEffect(() => {
    // if (process.env.NODE_ENV === 'development') {
    //   props.history.push('/callback');
    //   return;
    // }
    const authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(), new NoHashQueryStringUtils(), window.location, new DefaultCrypto());
    // .well-knownエンドポイントからOIDCのエンドポイント情報を取得
    AuthorizationServiceConfiguration.fetchFromIssuer(environment.OPServer, new FetchRequestor())
      .then((response) => {
        const authRequest = new AuthorizationRequest({
          client_id: environment.clientId,
          redirect_uri: environment.redirectURL,
          scope: environment.oauth2Scope,
          response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
          state: undefined,
        });
        // 認可エンドポイントにアクセスし、認証を行う
        // 認証に成功すると、redirect_uriで指定したページに遷移する（その際、クエリパラメータに認可コードが付与される）
        authorizationHandler.performAuthorizationRequest(response, authRequest);
      }).catch((error) => {
        console.error(JSON.stringify(error));
      });
  });

  return (
    <FpLoading />
  );
}
